<template>
  <div class="pdf-template-config">
    <el-card>
      <div slot="header" class="clearfix">
        <span style="font-size: 18px; font-weight: bold;">{{ pageTitle }}</span>
      </div>

      <el-row :gutter="20">
        <!-- 左侧：配置表单 -->
        <el-col :span="10">
          <el-card shadow="never">
            <div slot="header">
              <i class="el-icon-edit"></i> 填充配置
            </div>

            <el-form :model="formData" label-width="100px">
              <el-form-item label="税号">
                <el-input 
                  v-model="formData.taxNumber" 
                  placeholder="请输入税号"
                  @input="handleFormChange">
                </el-input>
              </el-form-item>

              <el-form-item label="姓名">
                <el-input 
                  v-model="formData.fullName" 
                  placeholder="请输入姓名"
                  @input="handleFormChange">
                </el-input>
              </el-form-item>

              <el-form-item label="出生日期">
                <el-input 
                  v-model="formData.dateOfBirth" 
                  placeholder="请输入出生日期"
                  @input="handleFormChange">
                </el-input>
              </el-form-item>

              <el-form-item label="地址">
                <el-input 
                  v-model="formData.address" 
                  type="textarea"
                  :rows="3"
                  placeholder="请输入地址"
                  @input="handleFormChange">
                </el-input>
              </el-form-item>

              <el-divider>坐标配置（可选）</el-divider>

              <el-form-item label="字体大小">
                <div style="display: flex; align-items: center; gap: 20px;">
                  <div>
                    <el-input-number 
                      v-model="fontSize" 
                      :min="6" 
                      :max="72"
                      controls-position="right"
                      style="width: 100px;"
                      @change="handleFormChange">
                    </el-input-number>
                    <span style="margin-left: 8px; color: #909399; font-size: 12px;">建议8-14</span>
                  </div>
                  <div>
                    <span style="margin-right: 8px;">换行:</span>
                    <el-input-number 
                      v-model="lineBreakThreshold" 
                      :min="500" 
                      :max="2000"
                      :step="50"
                      controls-position="right"
                      style="width: 100px;"
                      @change="handleFormChange">
                    </el-input-number>
                    <span style="margin-left: 8px; color: #909399; font-size: 12px;">X坐标</span>
                  </div>
                </div>
              </el-form-item>

              <el-form-item label="显示设置">
                <div style="display: flex; align-items: center; gap: 20px;">
                  <div>
                    <span style="margin-right: 8px;">颜色:</span>
                    <el-color-picker 
                      v-model="fontColor" 
                      show-alpha
                      @change="handleFormChange">
                    </el-color-picker>
                    <span 
                      :style="{
                        marginLeft: '8px',
                        display: 'inline-block',
                        width: '60px',
                        height: '28px',
                        lineHeight: '28px',
                        textAlign: 'center',
                        border: '1px solid #dcdfe6',
                        borderRadius: '4px',
                        backgroundColor: fontColor,
                        color: getContrastColor(fontColor),
                        fontSize: '12px'
                      }">
                      {{ fontColor }}
                    </span>
                  </div>
                  <div>
                    <span style="margin-right: 8px;">压缩:</span>
                    <el-switch 
                      v-model="compress" 
                      active-text="开" 
                      inactive-text="关"
                      @change="handleFormChange">
                    </el-switch>
                  </div>
                </div>
              </el-form-item>

              <el-form-item label="税号坐标">
                <div style="display: flex; align-items: center; gap: 10px;">
                  <span style="width: 20px;">X:</span>
                  <el-input-number 
                    v-model="coordinates.taxNumber.x" 
                    :min="0" 
                    :max="1000"
                    controls-position="right"
                    style="width: 120px;"
                    @change="handleCoordinateChange">
                  </el-input-number>
                  <span style="width: 20px; margin-left: 10px;">Y:</span>
                  <el-input-number 
                    v-model="coordinates.taxNumber.y" 
                    :min="0" 
                    :max="1000"
                    controls-position="right"
                    style="width: 120px;"
                    @change="handleCoordinateChange">
                  </el-input-number>
                </div>
              </el-form-item>

              <el-form-item label="姓名坐标">
                <div style="display: flex; align-items: center; gap: 10px;">
                  <span style="width: 20px;">X:</span>
                  <el-input-number 
                    v-model="coordinates.fullName.x" 
                    :min="0" 
                    :max="1000"
                    controls-position="right"
                    style="width: 120px;"
                    @change="handleCoordinateChange">
                  </el-input-number>
                  <span style="width: 20px; margin-left: 10px;">Y:</span>
                  <el-input-number 
                    v-model="coordinates.fullName.y" 
                    :min="0" 
                    :max="1000"
                    controls-position="right"
                    style="width: 120px;"
                    @change="handleCoordinateChange">
                  </el-input-number>
                </div>
              </el-form-item>

              <el-form-item label="日期坐标">
                <div style="display: flex; align-items: center; gap: 10px;">
                  <span style="width: 20px;">X:</span>
                  <el-input-number 
                    v-model="coordinates.dateOfBirth.x" 
                    :min="0" 
                    :max="1000"
                    controls-position="right"
                    style="width: 120px;"
                    @change="handleCoordinateChange">
                  </el-input-number>
                  <span style="width: 20px; margin-left: 10px;">Y:</span>
                  <el-input-number 
                    v-model="coordinates.dateOfBirth.y" 
                    :min="0" 
                    :max="1000"
                    controls-position="right"
                    style="width: 120px;"
                    @change="handleCoordinateChange">
                  </el-input-number>
                </div>
              </el-form-item>

              <el-form-item label="地址坐标">
                <div style="display: flex; align-items: center; gap: 10px;">
                  <span style="width: 20px;">X:</span>
                  <el-input-number 
                    v-model="coordinates.address.x" 
                    :min="0" 
                    :max="1000"
                    controls-position="right"
                    style="width: 120px;"
                    @change="handleCoordinateChange">
                  </el-input-number>
                  <span style="width: 20px; margin-left: 10px;">Y:</span>
                  <el-input-number 
                    v-model="coordinates.address.y" 
                    :min="0" 
                    :max="1000"
                    controls-position="right"
                    style="width: 120px;"
                    @change="handleCoordinateChange">
                  </el-input-number>
                </div>
              </el-form-item>

              <el-form-item>
                <el-button 
                  @click="resetForm"
                  icon="el-icon-refresh-left">
                  重置
                </el-button>
              </el-form-item>

              <el-alert
                title="提示"
                type="info"
                :closable="false"
                style="margin-top: 20px;">
                <div>1. 填写表单内容后点击"生成预览"查看效果</div>
                <div>2. 调整坐标可以改变文字在PDF中的位置</div>
                <div>3. 坐标系统：左上角为原点(0,0)，向右为X轴，向下为Y轴</div>
              </el-alert>
            </el-form>
          </el-card>
        </el-col>

        <!-- 右侧：预览区域 -->
        <el-col :span="14">
          <el-card shadow="never" style="height: 100%;">
            <div slot="header" style="display: flex; align-items: center; justify-content: space-between;">
              <span><i class="el-icon-picture"></i> 实时预览</span>
              <div>
                <el-button 
                  type="primary" 
                  size="small"
                  @click="generatePreview" 
                  :loading="generating"
                  icon="el-icon-view">
                  生成预览
                </el-button>
                <el-button 
                  type="success" 
                  size="small"
                  @click="downloadJpg" 
                  :disabled="!previewUrl"
                  icon="el-icon-download">
                  下载JPG
                </el-button>
              </div>
            </div>

            <div class="preview-container">
              <div v-if="!previewUrl" class="no-preview">
                <i class="el-icon-picture-outline"></i>
                <p>暂无预览</p>
                <p class="hint">填写左侧表单后点击“生成预览”按钮</p>
              </div>
              <div v-else class="preview-image">
                <el-image 
                  :src="previewUrl" 
                  fit="scale-down"
                  :preview-src-list="[previewUrl]">
                  <div slot="error" class="image-error">
                    <i class="el-icon-picture-outline"></i>
                    <p>图片加载失败</p>
                  </div>
                </el-image>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'PdfTemplateConfig',
  data() {
    return {
      pageTitle: 'PDF模板配置',
      formData: {
        taxNumber: '',
        fullName: '',
        dateOfBirth: '',
        address: ''
      },
      fontSize: 20, // 字体大小，默认20
      lineBreakThreshold: 1000, // 地址换行阈倿，默认1000
      fontColor: 'rgba(62, 60, 60, 1)', // 字体颜色，默认深灰色
      compress: true, // 是否压缩图片，默认开启
      coordinates: {
        taxNumber: { x: 100, y: 385 },
        fullName: { x: 400, y: 385 },
        dateOfBirth: { x: 980, y: 385 },
        address: { x: 200, y: 465 }
      },
      generating: false,
      previewUrl: null,
      autoPreview: false // 是否自动预览
    }
  },
  mounted() {
    this.loadPageTitle()
    // 加载默认配置
    this.loadDefaultConfig()
    // 加载示例数据
    this.loadSampleData()
  },
  methods: {
    // 动态加载页面标题
    async loadPageTitle() {
      try {
        const menuData = localStorage.getItem('admin_menu_data')
        if (menuData) {
          const menus = JSON.parse(menuData)
          const allMenus = menus.menus || []
          const currentMenu = allMenus.find(m => m.url === this.$route.path)
          if (currentMenu) {
            this.pageTitle = currentMenu.name
          }
        }
      } catch (error) {
        console.error('加载页面标题失败:', error)
      }
    },

    // 加载示例数据
    loadSampleData() {
      this.formData = {
        taxNumber: '123-456-789-000',
        fullName: 'JUAN DELA CRUZ',
        dateOfBirth: '01/15/1990',
        address: 'UNIT 123, SAMPLE STREET, BARANGAY TEST, CITY OF MANILA'
      }
    },
    
    // 加载默认配置
    async loadDefaultConfig() {
      try {
        const response = await this.$axios.get('/admin/ocr/common-config/default/BIR')
        
        if (response.data.code === 200 && response.data.data) {
          const config = response.data.data
          
          // 应用配置
          this.fontSize = config.fontSize || 20
          this.lineBreakThreshold = config.lineBreakThreshold || 1000
          this.fontColor = config.fontColor || 'rgba(62, 60, 60, 1)'
          this.compress = config.compress === 1
          
          this.coordinates = {
            taxNumber: { x: config.taxNumberX || 100, y: config.taxNumberY || 385 },
            fullName: { x: config.fullNameX || 400, y: config.fullNameY || 385 },
            dateOfBirth: { x: config.dateOfBirthX || 980, y: config.dateOfBirthY || 385 },
            address: { x: config.addressX || 200, y: config.addressY || 465 }
          }
          
          console.log('已加载默认配置:', config.configName)
        }
      } catch (error) {
        console.log('使用内置默认配置')
      }
    },

    // 表单内容变化
    handleFormChange() {
      // 可以在这里实现自动预览
      if (this.autoPreview) {
        this.debounceGeneratePreview()
      }
    },

    // 坐标变化
    handleCoordinateChange() {
      // 坐标变化时也可以触发自动预览
      if (this.autoPreview && this.previewUrl) {
        this.debounceGeneratePreview()
      }
    },

    // 防抖生成预览
    debounceGeneratePreview() {
      clearTimeout(this.previewTimer)
      this.previewTimer = setTimeout(() => {
        this.generatePreview()
      }, 1000)
    },

    // 生成预览
    async generatePreview() {
      // 验证必填项
      if (!this.formData.taxNumber && !this.formData.fullName && 
          !this.formData.dateOfBirth && !this.formData.address) {
        this.$message.warning('请至少填写一项内容')
        return
      }

      this.generating = true

      try {
        const token = localStorage.getItem('admin_token')
        
        // 构建请求数据
        const requestData = {
          ...this.formData,
          coordinates: this.coordinates,
          fontSize: this.fontSize,
          lineBreakThreshold: this.lineBreakThreshold,
          fontColor: this.fontColor,
          compress: this.compress
        }
        
        console.log('PDF预览请求数据:', requestData)
        console.log('字体大小:', this.fontSize, typeof this.fontSize)

        const response = await axios.post('/admin/pdf/template/preview', requestData, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          responseType: 'blob'
        })

        // 创建预览URL
        const blob = new Blob([response.data], { type: 'image/jpeg' })
        
        // 释放旧的URL
        if (this.previewUrl) {
          URL.revokeObjectURL(this.previewUrl)
        }
        
        this.previewUrl = URL.createObjectURL(blob)
        
        this.$message.success('预览生成成功')
      } catch (error) {
        console.error('生成预览失败', error)
        this.$message.error('生成预览失败：' + (error.response?.data?.msg || error.message))
      } finally {
        this.generating = false
      }
    },

    // 下载JPG
    downloadJpg() {
      if (!this.previewUrl) {
        this.$message.warning('请先生成预览')
        return
      }

      const link = document.createElement('a')
      link.href = this.previewUrl
      
      // 生成文件名
      const now = new Date()
      const fileName = `BIR_Preview_${now.getFullYear()}${String(now.getMonth()+1).padStart(2,'0')}${String(now.getDate()).padStart(2,'0')}_${String(now.getHours()).padStart(2,'0')}${String(now.getMinutes()).padStart(2,'0')}${String(now.getSeconds()).padStart(2,'0')}.jpg`
      
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      this.$message.success('下载成功')
    },

    // 重置表单
    resetForm() {
      this.formData = {
        taxNumber: '',
        fullName: '',
        dateOfBirth: '',
        address: ''
      }
      
      // 重新加载默认配置
      this.loadDefaultConfig()

      if (this.previewUrl) {
        URL.revokeObjectURL(this.previewUrl)
        this.previewUrl = null
      }

      this.$message.info('已重置')
    },
    
    // 获取对比颜色（用于颜色预览文字）
    getContrastColor(hexColor) {
      if (!hexColor) return '#000'
      
      // 移除 # 号
      const color = hexColor.replace('#', '')
      
      // 解析 RGB
      const r = parseInt(color.substr(0, 2), 16)
      const g = parseInt(color.substr(2, 2), 16)
      const b = parseInt(color.substr(4, 2), 16)
      
      // 计算亮度
      const brightness = (r * 299 + g * 587 + b * 114) / 1000
      
      // 亮度高于 128 使用黑色文字，否则使用白色文字
      return brightness > 128 ? '#000000' : '#FFFFFF'
    }
  },

  beforeDestroy() {
    // 清理预览URL
    if (this.previewUrl) {
      URL.revokeObjectURL(this.previewUrl)
    }
    if (this.previewTimer) {
      clearTimeout(this.previewTimer)
    }
  }
}
</script>

<style scoped>
.pdf-template-config {
  padding: 20px;
}

.preview-container {
  min-height: 600px;
  max-height: calc(100vh - 200px);
  overflow-y: auto;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 10px;
}

.no-preview {
  text-align: center;
  color: #909399;
}

.no-preview i {
  font-size: 80px;
  color: #C0C4CC;
}

.no-preview p {
  margin: 15px 0 5px 0;
  font-size: 16px;
}

.no-preview .hint {
  font-size: 14px;
  color: #C0C4CC;
}

.preview-image {
  width: 100%;
  text-align: center;
}

.preview-image .el-image {
  width: 100%;
  height: auto;
  max-width: 100%;
}

.image-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
  color: #909399;
}

.image-error i {
  font-size: 60px;
  color: #C0C4CC;
  margin-bottom: 15px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.el-input-number {
  width: 100%;
}
</style>
